export default function Dashboard() {
  return <h1>Dashboard MyShopCity</h1>;
}

